<template>
	<div class="user_navleft">
		<div class="user_navlist">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_usericon.png" alt=""></i><span>账户设置</span></h5>
			<ul>
				<li  :class="{active:index=='ttshop_usernews'}" @click="goTtshop_usernews"><span>个人信息</span></li>
				<li  :class="{active:index=='ttshop_siterun'}" @click="goTtshop_siterun"><span>地址管理</span></li>
				<!-- <li><span>账户安全</span></li> -->
			</ul>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      index:''
    };
  },
  methods: {
    // 个人中心
    goTtshop_usernews() {
      this.$router.push("/ttshop_usernews");
    },
    // 地址管理
    goTtshop_siterun(){
      this.$router.push("/ttshop_siterun");
    },
  },
  created() {
    console.log(this.$route.name);
    this.index = this.$route.name
  },
};
</script>

<style lang="scss" scoped>
	.user_navleft{
		float: left;
		width: 190px;
		min-height: 537px;
		margin-right: 10px;
		background: #fff;
		.user_navlist{
			width: 100%;
			padding: 12px 0;
			box-sizing: border-box;
			border-bottom: 1px solid #EBEBEB;
			h5{
				width: 100%;
				padding: 0 12px 13px 12px;
				box-sizing: border-box;
				i{
					float: left;
					width: 16px;
					height: 16px;
					margin-top: 3px;
					margin-right: 4px;
					img{
						display: block;
						width: 100%;
					}
				}
				span{
					float: left;
					font-size: 16px;
					color: #333;
					font-weight: 500;
				}
			}
			ul{
				li{
					display: block;
					width: 100%;
					padding: 8px 32px;
					box-sizing: border-box;
					span{
						font-size: 12px;
						color: #999;
						cursor: pointer;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						&:hover{
							color: #ff0e25;
						}
					}
					&.active span{
						color: #ff0e25;
					}
				}
			}
			&:last-child{
				border-bottom: 0;
			}
		}
	}
</style>
